module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.hidePage) ? _c('div', [_c('h1', [_vm._v("Audience Matters Automatic Login Page")]), _vm._v(" "), _c('div', [_vm._v("\n    if you see this page, please contact the Audience Matters Developer team.\n    \n  ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55f89de5","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/login/OKTALoginPage.vue
// module id = 2087
// module chunks = 0